import flow from "lodash/flow";
import { isEmpty } from "lodash/fp";
import getOr from "lodash/fp/getOr";
import pick from "lodash/fp/pick";

const selectShowAddToOrderButton = flow(
  getOr({}, ["app"]),
  pick(["formData", "volumentalData"]),
  ({ formData, volumentalData }) => {
    return (
      !formData.hideAddToOrderButtonIfNoVolumentalData ||
      !isEmpty(volumentalData)
    );
  }
);

export default selectShowAddToOrderButton;
